import React, { useState } from 'react';

import { ChevronDown, ChevronUp } from '@xsolla/ui-icons';

import { SpaceBetweenBlock } from '../../../styled';
import {
  CardHeader,
  CardHeaderDescription,
  ContentWrapper,
  HeaderIconWrapper,
  HeaderWrapper,
  StatusWrapper,
  Wrapper
} from './styles';
import { Props } from './types';

const ToggleBoxInForm = ({
  title,
  children,
  description,
  openByDefault = true,
  status,
  statusType,
  disabled = false
}: Props): JSX.Element => {
  const [showContent, setShowContent] = useState<boolean>(openByDefault);

  const switchShowContent = () => {
    if (!disabled) {
      setShowContent((prev) => !prev);
    }
  };

  return (
    <Wrapper>
      <HeaderWrapper onClick={switchShowContent}>
        <HeaderIconWrapper>
          {showContent ? <ChevronUp size={22} /> : <ChevronDown size={22} />}
        </HeaderIconWrapper>
        <CardHeader disabled={disabled}>
          <SpaceBetweenBlock>
            <span>{title}</span>

            {status || (statusType && <StatusWrapper status={statusType}>{status}</StatusWrapper>)}
          </SpaceBetweenBlock>
          {description && <CardHeaderDescription>{description}</CardHeaderDescription>}
        </CardHeader>
      </HeaderWrapper>
      <ContentWrapper isOpenContent={showContent}>{children}</ContentWrapper>
    </Wrapper>
  );
};

export default ToggleBoxInForm;
